import { Azienda } from "./Azienda";
import DeliverectChannelRegistrationBodyRequest from "./DeliverectChannelRegistrationBodyRequest";

export class Ristorante {
    id: string;
    stripeAccountId: string;
    nome: string;
    descrizione: string;
    telefono: string;
    email: string;
    visibile: boolean;
    tipologiaOrdinazione: "MULTIPLO" | "IMMEDIATO";
    tipologiaConnessioneCliente: "SINGOLA" | "DOPPIA";
    firebaseId: string;
    importoMinimoPagamentoOnline: number;
    costoCoperto: number;
    posizione: string;
    coordinate: string;
    pagamentoPortaConto: boolean;
    pagamentoCassa: boolean;
    pagamentoOnline: boolean;
    azienda: Azienda;
    urlLogo: string;
    urlCopertina: string;
    slotPrenotazione: number;
    ristoranteDeliverect?: DeliverectChannelRegistrationBodyRequest;

    constructor() {
        this.id = "";
        this.stripeAccountId = "";
        this.nome = "";
        this.descrizione = "";
        this.telefono = "";
        this.email = "";
        this.visibile = false;
        this.tipologiaOrdinazione = "MULTIPLO";
        this.tipologiaConnessioneCliente = "SINGOLA";
        this.firebaseId = "";
        this.importoMinimoPagamentoOnline = 0;
        this.costoCoperto = 0;
        this.posizione = "";
        this.coordinate = "";
        this.pagamentoPortaConto = false;
        this.pagamentoCassa = false;
        this.pagamentoOnline = false;
        this.azienda = new Azienda();
        this.urlLogo = "";
        this.urlCopertina = "";
        this.slotPrenotazione = 0;
    }

    static fromJson(json: any): Ristorante {
        let result = new Ristorante();
        result.id = json.id;
        result.nome = json.nome;
        result.descrizione = json.descrizione;
        result.telefono = json.telefono;
        result.email = json.email;
        result.visibile = json.visibile;
        result.tipologiaOrdinazione = json.tipologiaOrdinazione;
        result.tipologiaConnessioneCliente = json.tipologiaConnessioneCliente;
        result.firebaseId = json.firebaseId;
        result.importoMinimoPagamentoOnline = json.importoMinimoPagamentoOnline;
        result.costoCoperto = json.costoCoperto;
        result.posizione = json.posizione;
        result.coordinate = json.coordinate;
        result.pagamentoPortaConto = json.pagamentoPortaConto;
        result.pagamentoCassa = json.pagamentoCassa;
        result.pagamentoOnline = json.pagamentoOnline;
        result.urlLogo = json.urlLogo;
        result.urlCopertina = json.urlCopertina;
        result.slotPrenotazione = json.slotPrenotazione;

        if (json.azienda) {
            result.azienda = Azienda.fromJson(json.azienda);
        }

        if (json.ristoranteDeliverect) {
            result.ristoranteDeliverect = DeliverectChannelRegistrationBodyRequest.fromJson(json.ristoranteDeliverect);
        }

        return result;
    }
}